import { useChapterStore } from '../../shared/store/useChapterStore';
import { useChapter } from '../../shared/hooks/useChapter';
import { useEffect } from 'react';
import { useMissionStore } from '../../shared/store/useMissionStore';
import { usePickUpWhereYouLeftOff } from '@/pages/home/hooks/usePickUpWhereYouLeftOff';

export const useRoot = () => {
  const { errors } = useChapter();
  const chapter = useChapterStore((state) => state.chapter);
  const mission = useMissionStore((state) => state.mission);
  const showAssessment = useChapterStore((state) => state.showAssessment);
  const showReflectionVideoSection = useChapterStore((state) => state.showReflectionVideoSection);
  const { setLastChapterOpened } = usePickUpWhereYouLeftOff();

  useEffect(() => {
    if (chapter?.uuid && mission?.documentId) {
      setLastChapterOpened({
        chapterUUID: chapter?.uuid || '',
        missionDocumentId: mission?.documentId || '',
      });
    }
  }, [chapter, mission, setLastChapterOpened]);

  return {
    chapter,
    showAssessment,
    showReflectionVideoSection,
    errors,
  };
};
